/**
 * @author Gananath Athukkorala
 * @version 0.1
 * @since 4/19/2023
 */

import React from "react"
import { useNavigate } from "react-router-dom"
import "../styles/ControlPanelItem.scss"
import { Skeleton } from "@mui/material"

const ControlPanelItem = (props) => {
  const navigate = useNavigate()
  const Navi = () => {
    if (props.isRestricted === true) {
      navigate("/errorPage403")
    } else if (props.isRestricted === false) {
      navigate(props.path)
    }
  }
  return (
    <div className="card">
      {props.isLoading ? (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Skeleton variant="circular" width={60} height={60} />
            <br />
          </div>
          <Skeleton animation="wave" />
        </div>
      ) : (
        <div onClick={Navi} key={props.id}>
          {props.icon}
          <br />
          <br />
          <p>{props.action}</p>
        </div>
      )}
    </div>
  )
}

export default ControlPanelItem
